import { ServiceRegistryFormData } from '@/app/registry/service-registry/_hooks/use-service-form-validation'
import { useServiceOAuthConnection } from '@/app/registry/service-registry/_hooks/use-service-oauth-connection'
import { toast } from '@/components/ui/toaster'
import { useCreateServiceRegistryMutation } from '@/hooks/api/use-create-service-registry-mutation'
import { useTranslate } from '@tolgee/react'
import React from 'react'
import { ServiceToolsDialogData } from '../tab'
import { ServiceRegistryBaseDialog } from './base-dialog'

type AddServiceRegistryDialogProps = {
  open: boolean
  onOpenChange: React.Dispatch<React.SetStateAction<boolean>>
  setToolsDialogData: React.Dispatch<React.SetStateAction<ServiceToolsDialogData>>
  setIsToolsDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export function AddServiceRegistryDialog(props: AddServiceRegistryDialogProps) {
  const { open, onOpenChange, setIsToolsDialogOpen, setToolsDialogData } = props
  const { t } = useTranslate()

  const { mutateAsync: createServiceMutation, isPending: isServiceCreatePending } =
    useCreateServiceRegistryMutation()

  const { oauthInit, isConnecting, connectionState, handleOAuthCallback, clearOAuthState } =
    useServiceOAuthConnection({
      onSuccess: () => {
        toast.success(t('serviceRegistry.addDialog.toast.oauthSuccess'))
      },
      onError: (connectionError) => {
        toast.error(t('serviceRegistry.addDialog.toast.connectionFailed'))
        console.error(connectionError)
      },
    })

  const onSubmit = async (formData: ServiceRegistryFormData) => {
    try {
      const { access_token, token_type, expires_in, refresh_token, scope } =
        connectionState?.tokenResponse || {}

      const response = await createServiceMutation({
        name: formData.name,
        serviceType: formData.serviceType,
        url: formData.url,
        key: formData.key,
        access_token,
        token_type,
        refresh_token,
        scope: scope?.split(' '),
        expires_in,
        clientId: connectionState?.clientRegistration?.client_id,
        tokenUrl: connectionState?.metadata?.token_endpoint,
      })
      toast.success(t('serviceRegistry.addDialog.toast.success', { serviceName: formData.name }))
      if (response?.tools?.length) {
        setToolsDialogData({
          serviceName: formData.name,
          tools: response?.tools || [],
        })
        setIsToolsDialogOpen(true)
      }
      onOpenChange(false)
    } catch (registrationError) {
      toast.error(t('serviceRegistry.addDialog.toast.error'))
    }
  }

  return (
    <>
      <ServiceRegistryBaseDialog
        open={open}
        onOpenChange={onOpenChange}
        onSubmit={onSubmit}
        oauthInit={oauthInit}
        connectionState={connectionState}
        isOAuthConnecting={isConnecting}
        disabled={isServiceCreatePending || isConnecting}
        loading={isServiceCreatePending}
        handleOAuthCallback={handleOAuthCallback}
        clearOAuthState={clearOAuthState}
      />
    </>
  )
}
